/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_State_LockedInputs */

const en_signin_state_locked = /** @type {(inputs: Signin_State_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This account is locked after too many attempts. Ask your admin to unlock it.`)
};

/** @type {(inputs: Signin_State_LockedInputs) => LocalizedString} */
const ar_signin_state_locked = en_signin_state_locked;

/** @type {(inputs: Signin_State_LockedInputs) => LocalizedString} */
const he_signin_state_locked = en_signin_state_locked;

/** @type {(inputs: Signin_State_LockedInputs) => LocalizedString} */
const ur_signin_state_locked = en_signin_state_locked;

/** @type {(inputs: Signin_State_LockedInputs) => LocalizedString} */
const es_signin_state_locked = en_signin_state_locked;

/** @type {(inputs: Signin_State_LockedInputs) => LocalizedString} */
const fr_signin_state_locked = en_signin_state_locked;

/** @type {(inputs: Signin_State_LockedInputs) => LocalizedString} */
const de_signin_state_locked = en_signin_state_locked;

/** @type {(inputs: Signin_State_LockedInputs) => LocalizedString} */
const pt_signin_state_locked = en_signin_state_locked;

/** @type {(inputs: Signin_State_LockedInputs) => LocalizedString} */
const hi_signin_state_locked = en_signin_state_locked;

/** @type {(inputs: Signin_State_LockedInputs) => LocalizedString} */
const bn_signin_state_locked = en_signin_state_locked;

/**
* | output |
* | --- |
* | "This account is locked after too many attempts. Ask your admin to unlock it." |
*
* @param {Signin_State_LockedInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_state_locked = /** @type {((inputs?: Signin_State_LockedInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_State_LockedInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_state_locked(inputs)
	if (locale === "he") return he_signin_state_locked(inputs)
	if (locale === "ur") return ur_signin_state_locked(inputs)
	if (locale === "es") return es_signin_state_locked(inputs)
	if (locale === "fr") return fr_signin_state_locked(inputs)
	if (locale === "de") return de_signin_state_locked(inputs)
	if (locale === "pt") return pt_signin_state_locked(inputs)
	if (locale === "hi") return hi_signin_state_locked(inputs)
	if (locale === "bn") return bn_signin_state_locked(inputs)
	return /** @type {LocalizedString} */ ("This account is locked after too many attempts. Ask your admin to unlock it.")
});